import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\UpdateDossierFlowersDefaultsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierFlowersDefaultsController.php
* @route '/api/dossier/update-flowers-defaults/{dossier}'
*/
const UpdateDossierFlowersDefaultsController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierFlowersDefaultsController.url(args, options),
    method: 'put',
})

UpdateDossierFlowersDefaultsController.definition = {
    methods: ["put"],
    url: '/api/dossier/update-flowers-defaults/{dossier}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierFlowersDefaultsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierFlowersDefaultsController.php
* @route '/api/dossier/update-flowers-defaults/{dossier}'
*/
UpdateDossierFlowersDefaultsController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierFlowersDefaultsController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\UpdateDossierFlowersDefaultsController::__invoke
* @see app/Http/Controllers/Dossier/UpdateDossierFlowersDefaultsController.php
* @route '/api/dossier/update-flowers-defaults/{dossier}'
*/
UpdateDossierFlowersDefaultsController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierFlowersDefaultsController.url(args, options),
    method: 'put',
})

export default UpdateDossierFlowersDefaultsController